export enum MutationTypes {
    SET_BLOCK_BODY = "SET_BLOCK_BODY",
    PUSH_CHILD_TO_BLOCK_BODY = "PUSH_CHILD_TO_BLOCK_BODY",
    SPLICE_CHILD_TO_BLOCK_BODY = "SPLICE_CHILD_TO_BLOCK_BODY",
    SET_CHILDREN = "SET_CHILDREN",
    DELETE_BLOCK_BODY = "DELETE_BLOCK_BODY",
    DELETE_CHILD = "DELETE_CHILD",
}
